export interface AccountTableColumn {
  id:
    | "collapsible"
    | "eventType"
    | "nft"
    | "terms"
    | "interestRate"
    | "date"
    | "expiration"
    | "to"
    | "action";
  label: string;
  minWidth?: number;
  align?: "center" | "right" | "left";
  format?: (value: number) => string;
}

export const accountColumns = ({
  eventType = false,
  interestRate = false,
  to = false,
  collapsible = false,
}: {
  eventType?: boolean;
  interestRate?: boolean;
  to?: boolean;
  collapsible?: boolean;
}): AccountTableColumn[] => [
  ...(collapsible
    ? [
        {
          id: "collapsible" as const,
          label: null,
          minWidth: 50,
          align: "center" as const,
        },
      ]
    : []),
  ...(eventType
    ? [
        {
          id: "eventType" as const,
          label: null,
          minWidth: 70,
          align: "center" as const,
        },
      ]
    : []),
  {
    id: "nft",
    label: "NFT",
    minWidth: 200,
  },
  {
    id: "terms",
    label: "Terms",
    minWidth: 170,
  },
  ...(interestRate
    ? [
        {
          id: "interestRate" as const,
          label: "Interest Rate",
          minWidth: 120,
        },
      ]
    : []),
  {
    id: "date",
    label: "Date",
    minWidth: 125,
  },
  {
    id: "expiration",
    label: "Expiration",
    minWidth: 100,
  },
  ...(to
    ? [
        {
          id: "to" as const,
          label: "To",
          minWidth: 80,
        },
      ]
    : []),
  {
    id: "action",
    label: null,
    minWidth: 125,
    align: "center",
  },
];
